import React, { useState, useEffect, useContext } from 'react';
import {format, addDays, subDays} from "date-fns";

import * as net from "../../../lib/net";
import Fr_Input from "../../../lib/ui/fr_input";

class Tb_Cpy extends React.Component {
  constructor(props, context) {
    super(props);

    this.store = props.store;
    this.pos = props.store.pos;

    this.state = {};
    this.state.today = new Date();
    this.state.rta = [];

    this.state.gnr = "001";
    this.state.gso = {};

    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

    this.state.rs = "";
      this.state.rsa = [];
    this.state.tbo = {};
    this.state.background = "#fff";

    this.state.wnds = {};
    if(props.wnds) {
        this.state.rs = props.wnds.rs;
        this.state.rsa = props.wnds.rsa;
        this.state.tbo = props.wnds.tbo;
        this.state.rs = props.wnds.tbo.restname;
    }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }
    grp_style(row) {
      var css = {};
      css.background = "#008";
      if(this.state.gnr === row.vgrupp) css.background = "#080";
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.cb) {
        var ret = {};
        ret.ok = "999";
        this.props.cb(this.props.ctx, ret);
      }
      else this.props.ctx.setState({ wnds: {} });
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

    change_rs(e) {
        //let cdat = this.state.seldate;
        let rs = e.target.value;
        this.setState({rs: rs});
    }
    val_save (name, value) {
        //alert(JSON.stringify(name));
        //alert(JSON.stringify(value));
      var tbo = this.state.tbo;
      tbo[name] = value;
      this.setState({tbo: tbo});
    }
    cb_save (name, e) {
      const value = e.target.value;
      var bro = this.state.bro;
      bro[name] = value;
      this.setState({bro: bro});
      //setState({[name]: value});
    }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }

  tbo_init() {
    var self = this;

    var tbo = {};
    tbo.bordsnr = "";
    tbo.bordstyp = "RECTANGULAR";
    tbo.bordX = "120";
    tbo.bordXlen = "120";
    tbo.bordY = "80";
    tbo.bordYlen = "880";
    tbo.fg = "";
    tbo.bg = "";
    this.setState({tbo: tbo});
  }
  rts() {
    var self = this;
    var prm = {};
    prm.req = "pms.rt.rt_date";
    //prm.datum = this.state.datum;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));

        if(ret.ok != "000") {
            return;
        }
        self.setState({rta: ret.rco});
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  tb_copy() {
    var self = this;
    //alert(JSON.stringify(this.state.rs));
      if(this.state.tbo.restname.trim() == this.state.rs.trim()) {
          alert("Ej samma resurs");
          return;
      }
      this.state.tbo.restname = this.state.rs;
    var prm = {};
    //prm.req = "pms.rs_lt.lt_tb_save";
    prm.req = "pos.pos_tbv.tbv_add";
    prm.rs = this.state.rs;
    prm.tbo = this.state.tbo;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
    if(self.props.wnds.cb) {
        var ret = {};
        ret.ok = "000";
        self.props.cb(self.props.ctx, ret);
      }
      else self.props.ctx.setState({ wnds: {} });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

  render() {
    //if(!this.props.show) return "";

    var title = this.props.title;
    if(!title) title = "Gäst";
    //if(props.kro) alert(props.kro.krr00.kid);
    const popover = {
      position: 'absolute',
      top: '50px',
      zIndex: '2',
    }
    const cover = {
      position: 'fixed',
      top: '0px',
      right: '0px',
      bottom: '0px',
      left: '0px',
    }

	var html =
        <div className="mx_base">
        <div className="m3_backdrop" />
        <div className="m3_dlg mx_50 flex-col" style={ this.dlg_style() } draggable="true" >

        <div className="mx_h01">
            <div>BORD { this.state.tbo.bordsnr }</div>
        </div>
        <div className="mx_content flex">

            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row py-2">
                    <Fr_Input label="Resurs" className="text-left w150" text={this.state.tbo.restname} getValue={(e)=> this.val_save("restname", e) } />
                </div>
                <div className="flex-row py-2">
                    <Fr_Input label="Bordsnr" className="text-left w150" text={this.state.tbo.bordsnr} getValue={(e)=> this.val_save("bordsnr", e) } />
                </div>
            <div className="divider_green"></div>
                <select className="form-control sel_input" placeholder="Välj Resurs" onChange={(e) => this.change_rs(e)}>
                    { this.state.rsa.map((row, key) =>
                        <option key={key} value={row.restname}>{row.restname} : {row.fromtime} - {row.tilltime}</option>
                    )}
                </select>
            </form>
        </div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w200" onClick={() => this.wnd_close() } >
                AVBRYT
            </button>
            <div className="flex"></div>
            <div className="flex"></div>
            <button className="btn btn-hw-green w200" onClick={() => this.tb_copy() } >
                KOPIERA
            </button>

        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Tb_Cpy;
